<div [attr.class]="appTooltipStyle ? 'info' : 'tooltip'">
	<div [attr.class]="appTooltipStyle ? 'infoContainer' : position === 'top'? 'container': 'container_bottom'">
		<div [attr.class]="position === 'top'? 'triangle': 'triangle_bottom'" ></div>
		<div class="content" #content>
			<ng-container *ngTemplateOutlet="templateRef"></ng-container>
		</div>
	</div>
</div>

